import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { useStore } from '../../app/stores/store';
import ProfileContent from './ProfileContent';
import ProfileHeader from './ProfileHeader';

function ProfilePage() {
    const {username} = useParams<{username: string}>(); 
    const usStore = useStore();

    useEffect(() => {
        //usStore.profileStore.loadProfile(username!);
        if (username) {
            usStore.profileStore.loadProfile(username);
        }

        return () => { //'n >> ProfileFollowingsTaggle
            usStore.profileStore.setActiveTab(0);
        }
    }, [usStore.profileStore.loadProfile, username, usStore.profileStore.setActiveTab])

    if (usStore.profileStore.isLoadingProfile) return <LoadingComponent content='Loading profile...' />

    return (
        <Grid>
            <Grid.Column width='16' >
                {/* <ProfileHeader profile={usStore.profileStore.profile!} /> */}
                {/* {usStore.profileStore.profile && <ProfileHeader profile={usStore.profileStore.profile} /> } */}
                {usStore.profileStore.profile && 
                    <>
                        <ProfileHeader profile={usStore.profileStore.profile} /> 
                        <ProfileContent profile={usStore.profileStore.profile}  /> 
                    </>
                }
            </Grid.Column>
        </Grid>
    )
}

export default observer(ProfilePage);